import React, { useContext, useEffect, useState } from "react";
import { Whatsapp } from "./api";
import { FaWhatsapp } from "@react-icons/all-files/fa/FaWhatsapp";
import Link from "next/link";
import isMobile from "is-mobile";
import { StoreContext } from "../context/context";
import { useTranslation } from "../context/TranslationContext";

const WhatsappDesktop = () => {
  const { wpSupport, wpMessage } = useTranslation();
  const isPhone = isMobile();

  const [data, setData] = useState(false);
  const [text, setText] = useState("");
  const { currentRoutingTypeId, page } = useContext(StoreContext);
  useEffect(() => {
    Whatsapp().then((e) => {
      setData(e.data);
    });
  }, []);

  useEffect(() => {
    if (currentRoutingTypeId == "ProductDetail")
      setText(wpMessage.replaceAll("{Villa}", page.baslik));
    else setText("");
  }, [currentRoutingTypeId, page, wpMessage]);

  if (data && !isPhone)
    return (
      <Link href={`https://wa.me/${data.data[0].phone}?text=${text}`}>
        <a
          className="fixed bottom-0 right-0 bg-green-400 text-white py-2 flex items-center px-4 rounded-tl-lg z-50"
          target={"_blank"}
        >
          <FaWhatsapp size={30} className={"mr-2"} />
          <span className="font-medium">{wpSupport}</span>
        </a>
      </Link>
    );
};

export default WhatsappDesktop;
